// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\NewTopicCard\NewTopicCardRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';

// NewTopicCardRequestData is the class that NewTopicCardRequest serializes to/from
export interface NewTopicCardRequestData {
	
    Card : TopicCardData | null;
    SelectedTemplateOptionId : number | null;
	
}

// NewTopicCardRequestOptions is the class which may be passed to the NewTopicCardRequest constructor to define optional initial data values
export interface NewTopicCardRequestOptions {
	
    Card? : TopicCardOptions | null;
    SelectedTemplateOptionId? : number | null;
	
}

export class NewTopicCardRequest {
	
    public Card : DataSignal<TopicCard | null>;
    public SelectedTemplateOptionId : DataSignal<number | null>;
	

    constructor();
    constructor(data : NewTopicCardRequestOptions);
    constructor(data: NewTopicCardRequestOptions | null = null) {
	    
        this.Card = S.value<TopicCard | null>(null);
        this.SelectedTemplateOptionId = jsonableObservable(S.value<number | null>(data && data.SelectedTemplateOptionId !== undefined ? data.SelectedTemplateOptionId : null));
	    
    }

    static key(obj : NewTopicCardRequest) {
        return ;
    }
    
    static dataKey(obj : NewTopicCardRequestOptions) {
        return ;
    }

    static update(obj : NewTopicCardRequest, data : NewTopicCardRequestOptions) {
        S.freeze(() => {
	        
            if (data.SelectedTemplateOptionId !== undefined) obj.SelectedTemplateOptionId(data.SelectedTemplateOptionId);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/NewTopicCardRequest.ts